import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";

function AddEditSanitaryModal({
  show,
  handleClose,
  isEditMode,
  reportData,
  onSuccess,
  fundList,
  departmentList,
  userList,
}) {
  const user_name = localStorage.getItem("user_name");
  const user_id = localStorage.getItem("user_id");
  const token = localStorage.getItem("token");
  const API_URL = process.env.REACT_APP_SUPER_ADMIN_API_URL;

  const initialFormData = {
    type: "",
    memo_no: "",
    memo_date: "",
    name_of_works: "",
    alotment_head_id: "",
    alotment_amount: "",
    work_order_meno: "",
    work_order_date: "",
    engaged_agency: "",
    estimet_amount: "",
    lessper: "",
    aboveper: "",
    final_amount: "",
    date_of_agreement: "",
    duration: "",
    dateof_commencement: "",
    dateof_completion: "",
    name_of_concerned: user_id,
    processing_recieving_date: "",
    send_to: "",
    user_id: "",
    physical_status: "",
    remarks: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [resolutionCopyFile, setResolutionCopyFile] = useState(null);

  useEffect(() => {
    if (show) {
      if (isEditMode && reportData) {
        setFormData({
          type: reportData.type || "",
          memo_no: reportData.memo_no || "",
          memo_date: reportData.memo_date?.split(" ")[0] || "",
          name_of_works: reportData.name_of_works || "",
          alotment_head_id: reportData.alotment_head_id || "",
          alotment_amount: reportData.alotment_amount || "",
          work_order_meno: reportData.work_order_meno || "",
          work_order_date: reportData.work_order_date || "",
          engaged_agency: reportData.engaged_agency || "",
          estimet_amount: reportData.estimet_amount || "",
          lessper: reportData.lessper || "",
          aboveper: reportData.aboveper || "",
          final_amount: reportData.final_amount || "",
          date_of_agreement: reportData.date_of_agreement || "",
          duration: reportData.duration || "",
          dateof_commencement: reportData.dateof_commencement || "",
          dateof_completion: reportData.dateof_completion || "",
          name_of_concerned: reportData.name_of_concerned || user_id,
          processing_recieving_date: reportData.processing_recieving_date || "",
          send_to: reportData.send_to || "",
          user_id: reportData.user_id || "",
          physical_status: reportData.physical_status || "",
          remarks: reportData.remarks || "",
        });
      } else {
        setFormData(initialFormData);
      }
      setResolutionCopyFile(null);
    }
  }, [reportData, isEditMode, show, user_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newFormData = { ...formData, [name]: value };

    if (name === "lessper" && value) newFormData.aboveper = "";
    if (name === "aboveper" && value) newFormData.lessper = "";

    if (["estimet_amount", "lessper", "aboveper"].includes(name)) {
      const estimate = parseFloat(newFormData.estimet_amount) || 0;
      const less = parseFloat(newFormData.lessper) || 0;
      const above = parseFloat(newFormData.aboveper) || 0;
      let final = estimate;
      if (less > 0) final = estimate - (estimate * less) / 100;
      if (above > 0) final = estimate + (estimate * above) / 100;
      newFormData.final_amount = final.toFixed(2);
    }

    if (name === "send_to") newFormData.user_id = "";

    setFormData(newFormData);
  };

  const handleFileChange = (e) => setResolutionCopyFile(e.target.files[0]);

  const getFilteredUsers = () => {
    if (!formData.send_to || !Array.isArray(userList)) return [];
    return userList.filter((user) => user.department_id === formData.send_to);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const submissionData = new FormData();
    Object.keys(formData).forEach((key) => {
      submissionData.append(key, formData[key]);
    });
    if (resolutionCopyFile) {
      submissionData.append("resolution_copy", resolutionCopyFile);
    }
    if (isEditMode) {
      submissionData.append("id", reportData.id);
    }
    const url = isEditMode
      ? `${API_URL}/update-sanitary.php`
      : `${API_URL}/add-sanitary.php`;
    try {
      const response = await axios.post(url, submissionData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.success) {
        toast.success(
          isEditMode
            ? "Report updated successfully!"
            : "Report added successfully!"
        );
        onSuccess();
        handleClose();
      } else {
        toast.error(response.data.message || "An unknown error occurred.");
      }
    } catch (error) {
      toast.error("Failed to connect to the server. Please try again.");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {isEditMode ? "Edit Sanitary File" : "Add New File"}
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <div className="modal-body">
          <div className="container-fluid">
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">Type</label>
                <select
                  className="form-select"
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                >
                  <option value="">--Select Type--</option>
                  <option value="NIQ">NIQ</option>
                  <option value="NIEQ">NIEQ</option>
                  <option value="NIT">NIT</option>
                  <option value="NIET">NIET</option>
                  <option value="EIO">EIO</option>
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label">Memo No</label>
                <input
                  type="text"
                  className="form-control"
                  name="memo_no"
                  value={formData.memo_no}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Memo Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="memo_date"
                  value={formData.memo_date}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Name of Works</label>
                <input
                  type="text"
                  className="form-control"
                  name="name_of_works"
                  value={formData.name_of_works}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  Resolution copy of MCIC/BOC/Tender Committee
                </label>
                <input
                  type="file"
                  className="form-control"
                  name="resolution_copy"
                  onChange={handleFileChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Alotment Fund</label>
                <select
                  className="form-select"
                  name="alotment_head_id"
                  value={formData.alotment_head_id}
                  onChange={handleChange}
                >
                  <option value="">--Select Alotment Funds--</option>
                  {fundList.map((f) => (
                    <option key={f.id} value={f.id}>
                      {f.fund_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">Alotment Amount</label>
                <input
                  type="number"
                  className="form-control"
                  name="alotment_amount"
                  value={formData.alotment_amount}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Work Order Memo No</label>
                <input
                  type="text"
                  className="form-control"
                  name="work_order_meno"
                  value={formData.work_order_meno}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Work Order Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="work_order_date"
                  value={formData.work_order_date}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Date of Agreement</label>
                <input
                  type="date"
                  className="form-control"
                  name="date_of_agreement"
                  value={formData.date_of_agreement}
                  onChange={handleChange}
                />
              </div>

              <div className="col-12">
                <div className="row">
                  <div className="col-md-4">
                    <label className="form-label">Engaged Agency</label>
                    <input
                      type="text"
                      className="form-control"
                      name="engaged_agency"
                      value={formData.engaged_agency}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label">Estimet Amount</label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      name="estimet_amount"
                      value={formData.estimet_amount}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label">Less(%)</label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      name="lessper"
                      value={formData.lessper}
                      onChange={handleChange}
                      disabled={!!formData.aboveper}
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label">Above(%)</label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      name="aboveper"
                      value={formData.aboveper}
                      onChange={handleChange}
                      disabled={!!formData.lessper}
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label">Final Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      name="final_amount"
                      value={formData.final_amount}
                      readOnly
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <label className="form-label">Duration</label>
                <input
                  type="text"
                  className="form-control"
                  name="duration"
                  value={formData.duration}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Date of Commencement</label>
                <input
                  type="date"
                  className="form-control"
                  name="dateof_commencement"
                  value={formData.dateof_commencement}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Date of Completion</label>
                <input
                  type="date"
                  className="form-control"
                  name="dateof_completion"
                  value={formData.dateof_completion}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Name of Concerned</label>
                <input
                  type="text"
                  className="form-control"
                  value={user_name}
                  disabled
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  Processing / Recieving Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="processing_recieving_date"
                  value={formData.processing_recieving_date}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Send to</label>
                <select
                  className="form-select"
                  name="send_to"
                  value={formData.send_to}
                  onChange={handleChange}
                >
                  <option value="">--Select Department--</option>
                  {departmentList.map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.department_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">User</label>
                <select
                  className="form-select"
                  name="user_id"
                  value={formData.user_id}
                  onChange={handleChange}
                  disabled={!formData.send_to}
                >
                  <option value="">
                    {!formData.send_to
                      ? "--Select Department First--"
                      : "--Select User--"}
                  </option>
                  {getFilteredUsers().map((u) => (
                    <option key={u.id} value={u.id}>
                      {u.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label">Physical Status</label>
                <input
                  type="text"
                  className="form-control"
                  name="physical_status"
                  value={formData.physical_status}
                  onChange={handleChange}
                />
              </div>

              <div className="col-12">
                <label className="form-label">Remarks</label>
                <textarea
                  className="form-control"
                  name="remarks"
                  value={formData.remarks}
                  onChange={handleChange}
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            {isEditMode ? "Update" : "Submit"}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export default AddEditSanitaryModal;
